var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_722_32707)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 18C13.9706 18 18 13.9706 18 9C18 4.02944 13.9706 0 9 0C4.02944 0 0 4.02944 0 9C0 13.9706 4.02944 18 9 18Z",
    fill: "#262626"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.52369 5.41406C10.9035 5.51588 11.5729 6.33938 11.5729 6.48844C11.5729 6.59362 11.5476 6.82312 11.5476 6.96375C11.5476 7.05769 11.5813 7.20788 11.6488 7.41375C11.6319 7.55438 11.5391 7.62525 11.3698 7.62525C11.1167 7.62525 11.1876 7.34119 10.8118 6.77869C10.4068 6.17287 9.99731 6.04575 9.52144 6.01931C9.531 7.31081 9.56644 10.8658 9.56925 12.0887C10.8377 11.9042 11.5419 10.9569 11.7247 10.9569C11.826 10.9569 11.9531 11.0357 11.9531 11.2213C11.9531 11.6122 10.9507 12.4965 9.55012 12.6714C9.4455 13.8127 8.9055 15.1875 7.56562 15.1875C6.93169 15.1875 6.399 14.6981 6.399 14.13C6.399 13.7599 6.678 13.6012 6.93169 13.6012C7.18481 13.6012 7.4385 13.7863 7.4385 14.13C7.4385 14.3589 7.36256 14.5181 7.21069 14.6059C7.36256 14.7116 7.51444 14.7645 7.66687 14.7645C8.17425 14.7645 8.55562 13.8465 8.62087 12.6664C7.14262 12.429 5.76506 11.0205 5.76506 8.97356C5.76506 6.67125 7.19944 5.67562 8.60625 5.45344C8.63437 4.41844 9.17494 2.83781 10.5581 2.8125C11.3946 2.8125 11.7495 3.49988 11.7495 3.87C11.7495 4.24013 11.4834 4.39875 11.2174 4.39875C10.9507 4.39875 10.6847 4.18725 10.6847 3.87C10.6847 3.6585 10.7691 3.50887 10.9378 3.42056C10.8197 3.31481 10.6678 3.26194 10.4822 3.26194C9.7785 3.26194 9.558 4.74581 9.52369 5.41406ZM8.631 12.0448C8.62875 10.6757 8.61131 7.52063 8.60681 6.07106C7.30856 6.39 6.88162 7.93463 6.88162 8.97356C6.88162 10.6206 7.66012 11.7517 8.631 12.0448Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_722_32707"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCs);
export default __webpack_public_path__ + "static/media/cs.c5b5cea0d363a19d0f19ecd4fdc8e366.svg";
export { ForwardRef as ReactComponent };